// PrintableUsersTable.tsx
import React, { forwardRef } from "react";

type Column<T> = {
  title: string;
  accessor: (row: T) => React.ReactNode;
  width?: number | string;
};
type Props<T> = {
  title?: string;
  subtitle?: string;
  columns: Column<T>[];
  rows: T[];
};

function Inner<T>(
  { title, subtitle, columns, rows }: Props<T>,
  ref: React.Ref<HTMLDivElement>
) {
  return (
    <div ref={ref} style={{ direction: "rtl", padding: "16px" }}>
      {title && <h2 style={{ margin: "0 0 8px 0" }}>{title}</h2>}
      {subtitle && <div style={{ marginBottom: 12 }}>{subtitle}</div>}
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          tableLayout: "fixed",
        }}
      >
        <thead>
          <tr>
            {columns?.map((c, i) => (
              <th
                key={i}
                style={{
                  border: "1px solid #999",
                  padding: "6px 8px",
                  background: "#eee",
                  textAlign: "start",
                  width: c.width,
                  maxWidth: c.width,
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {c.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows?.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                style={{
                  textAlign: "center",
                  border: "1px solid #999",
                  padding: 16,
                }}
              >
                אין נתונים להצגה
              </td>
            </tr>
          ) : (
            rows?.map((r, ri) => (
              <tr key={ri}>
                {columns.map((c, ci) => (
                  <td
                    key={ci}
                    style={{
                      border: "1px solid #999",
                      padding: "6px 8px",
                      width: c.width,
                      maxWidth: c.width,
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {c.accessor(r)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

const AppPrintTable = forwardRef(Inner) as <T>(
  p: Props<T> & { ref?: React.Ref<HTMLDivElement> }
) => React.JSX.Element;

export default AppPrintTable;
export type { Column as PrintColumn };
